import * as z from "zod";
import { brandCompetitorIdFormat } from "../../ids";
import { BrandAliasSchema } from "./brand-alias";

export const MinimalBrandCompetitorSchema = z.object({
  id: brandCompetitorIdFormat.schema,
  competitorName: z.string(),
  website: z.string(),
  competitiveCategory: z.string(),
});
export type MinimalBrandCompetitor = z.infer<
  typeof MinimalBrandCompetitorSchema
>;

export const BrandCompetitorSchema = MinimalBrandCompetitorSchema.extend({
  competitiveSummary: z.string(),
  competitiveStrengths: z.string(),
  competitiveWeaknesses: z.string(),
  socialSentiment: z.string(),
  aliases: z.array(BrandAliasSchema),
  lastAnalysisAt: z.date().nullable(),
});
export type BrandCompetitor = z.infer<typeof BrandCompetitorSchema>;

export const BrandCompetitorAliasesSchema = z.object({
  id: brandCompetitorIdFormat.schema,
  competitorName: z.string(),
  aliases: z.array(BrandAliasSchema),
});
export type BrandCompetitorAliases = z.infer<
  typeof BrandCompetitorAliasesSchema
>;
